import { useCallback } from 'react';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

/**
 * reCAPTCHA v3 hook — invisible, score-based bot detection.
 *
 * Usage:
 *   const { getRecaptchaToken } = useRecaptcha();
 *   const token = await getRecaptchaToken('submit_lead');
 *   // Send token in your POST body as `recaptchaToken`
 */
export default function useRecaptcha() {
  const getRecaptchaToken = useCallback(async (action = 'submit') => {
    if (!SITE_KEY) return null;

    // Wait for grecaptcha to load (script is async)
    if (!window.grecaptcha?.ready) return null;

    return new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action })
          .then(resolve)
          .catch((err) => {
            console.error('reCAPTCHA error:', err);
            resolve(null);
          });
      });
    });
  }, []);

  return { getRecaptchaToken };
}
